/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pxk_Take_AllInputs */

const vi_pl_pxk_take_all = /** @type {(inputs: Pl_Pxk_Take_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy hết`)
};

/**

* @param {Pl_Pxk_Take_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pxk_take_all = /** @type {((inputs?: Pl_Pxk_Take_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pxk_Take_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pxk_take_all(inputs)
});